export enum LocalStorageKeys {
    token = 'token',
    refreshToken = 'refreshToken',
    username = 'username',
    keepMeLoggedIn = 'keepMeLoggedIn'
}